/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/AdminPage`).
 */

import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import AdminPage from "../pages/admin/AdminPage";
import LogoutPage from "../pages/auth/Logout/LogoutPage";
import { LayoutContextProvider } from "../../_metronic";
import Layout from "../../_metronic/layout/Layout";
import * as routerHelpers from "../router/RouterHelpers";
import AuthPage from "../pages/auth/AuthPage";
import styles from "./styles.module.scss";
import { LayoutSplashScreen } from "../../_metronic";
import { getUserByToken } from "../crud/auth.crud";
import * as authDuck from "../store/ducks/auth.duck";

export const Routes = withRouter(({ history }) => {
  const dispatch = useDispatch();
  const lastLocation = useLastLocation();
  routerHelpers.saveLastLocation(lastLocation);
  const { authData, isAuthorized, menuConfig, userLastLocation } = useSelector(
    ({ auth, builder: { menuConfig } }) => ({
      authData: auth.authData,
      menuConfig,
      // MUDAR
      // isAuthorized: auth.user != null && auth.user.role.name === "ADMIN",
      isAuthorized: auth.user != null && auth.user.email,
      userLastLocation: routerHelpers.getLastLocation()
    }),
    shallowEqual
  );
  const [isCheckingSession, setIsCheckingSession] = useState(Boolean(authData));

  useEffect(() => {
    let active = true;

    if (!authData) {
      setIsCheckingSession(false);
      return () => {
        active = false;
      };
    }

    getUserByToken()
      .then((user) => {
        if (active) dispatch(authDuck.actions.fulfillUser(user));
      })
      .catch(() => {
        if (active) dispatch(authDuck.actions.logout());
      })
      .finally(() => {
        if (active) setIsCheckingSession(false);
      });

    return () => {
      active = false;
    };
    // A validacao deve ocorrer uma vez, depois da reidratacao do Redux Persist.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isCheckingSession) {
    return <LayoutSplashScreen />;
  }

  return (
    /* Create `LayoutContext` from current `history` and `menuConfig`. */
    <LayoutContextProvider history={history} menuConfig={menuConfig}>
      <Switch>
        <Redirect exact from="/" to="/admin" />

        <Route path="/auth" component={AuthPage} />
        <Route path="/auth/login" component={AuthPage} />
        <Route path="/logout" component={LogoutPage} />
        {/* <Route path="/privacy-policy" component={PrivacyPolicyPage} /> */}

        {/* <Route path="/cadastrar-senha" component={CreateNewPassword} /> */}

        {isAuthorized ? (
          <Route path="/">
            <Layout>
              <div className={styles.contentMargin}>
                <AdminPage userLastLocation={userLastLocation} />
              </div>
            </Layout>
          </Route>
        ) : (
          <Redirect from="/admin" to="/logout" />
        )}
      </Switch>
    </LayoutContextProvider>
  );
});
